export default __webpack_public_path__ + "static/media/background.a82ba407.jpg";